<template>
<div>
  <el-table border fit highlight-current-row class="table-expand" size="small" :data="list" v-if="activeName === 'b'">
    <el-table-column label="型号" prop="xhname"></el-table-column>
    <el-table-column label="品牌" prop="source"></el-table-column>
    <el-table-column label="数量" prop="num"></el-table-column>
    <el-table-column label="单价" prop="price"></el-table-column>
    <el-table-column label="总价" prop="zprice"></el-table-column>
  </el-table>
  <el-descriptions title="" border class="expand" :column="3" size="small" v-if="activeName ==='a'">
    <el-descriptions-item label="报价日期">{{data.settime}}</el-descriptions-item>
    <el-descriptions-item label="负责人">{{data.rname}}</el-descriptions-item>
    <el-descriptions-item label="联系人">{{data.name}}</el-descriptions-item>
    <el-descriptions-item label="联系电话">{{data.phone}}</el-descriptions-item>
    <el-descriptions-item label="备注">{{data.description}}</el-descriptions-item>
  </el-descriptions>
</div>
</template>
<script>
import {defineComponent} from '@vue/composition-api'
export default defineComponent({
  components: {},
  props: {
    activeName: {
      type: String,
      default: ''
    },
    data: {
      type: Object,
      default: () => {}
    },
    list: {
      type: Array,
      default: () => {}
    }
  },
  setup() {

  }
})
</script>
<style lang="scss" scoped>
.table-expand {
  width: 96%;
  margin: auto;
}
.expand {
  margin: 0 20px;
}
</style>
